module.exports = __webpack_public_path__ + "img/tg_02 (12).ed9ee515.jpg";